import React, {useEffect, useRef} from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import {Grid} from "@mui/material";
import {VscChromeClose} from "react-icons/vsc";

import html2canvas from "html2canvas";
import BoxKitchen from "../Box/BoxKitchen";
import InputButton from "../../../../components/Inputs/InputButton";
import {LoadingButton} from "@mui/lab";
import {toPng} from 'html-to-image';
import {useTranslation} from "react-i18next";

export default function KitchenModal(props) {
    const {
        open,
        closeModalKitchen,
        handleClose,
        kitchenElements,
        kitchenElementsSecondarySide,
        setKitchenElementsSecondarySide,
        setKitchenElements,
        handleSubmit,
    } = props

    const {t} = useTranslation()

    const exportRef = useRef();

    const [isConfirmSlide1, setIsConfirmSlide1] = React.useState("")
    const [isConfirmSlide2, setIsConfirmSlide2] = React.useState("")

    const [side1, setSide1] = React.useState(false)
    const [side2, setSide2] = React.useState(false)

    const resetVar = () => {
        setIsConfirmSlide1("")
        setIsConfirmSlide2("")
        setSide1(false)
        setSide2(false)
    }

    useEffect(() => {
        if (open) {
            resetVar()
        }
    }, [open])

    useEffect(() => {
        // Realizamos en envio una vez hemos confirmado los dos lados
        if ((side1 && side2) || (side1 && kitchenElementsSecondarySide.length === 0)){
            handleSubmit(isConfirmSlide1, isConfirmSlide2)

            // Lo reseteamos para que no se envie de nuevo
            resetVar()
        }

    }, [side1, side2])

    const handleCancel = () => {
        closeModalKitchen()
    }

    const exportAsImage = async (element, imageFileName) => {
        toPng(element, {cacheBust: true, scale: 3})
            .then((dataUrl) => {
                const link = document.createElement('a')
                link.download = 'my-image-name.png'
                link.href = dataUrl
                if (isConfirmSlide1 === "") {
                    setIsConfirmSlide1(dataUrl)
                    setSide1(true)
                } else {
                    setIsConfirmSlide2(dataUrl)
                    setSide2(true)
                }
            })
            .catch((err) => {
                console.error(err)
            })
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                BackdropProps={{
                    style: {
                        background: 'rgba(0, 0, 0, .5)',
                        backdropFilter: ' blur(5px)',
                    },
                }}
            >
                <Box sx={{...style}}>
                    <Grid container spacing={1}>
                        <Grid item md={6}>
                            <h3 style={{marginTop: 5}}>{t('quotation.Generate quotation')}</h3>
                        </Grid>
                        <Grid item md={6}>
                            <div
                                style={{
                                    background: '#f6f6f6',
                                    padding: '5px 5px 0px 4px',
                                    width: 15,
                                    borderRadius: 50,
                                    float: 'right'
                                }}
                            >
                                <VscChromeClose
                                    onClick={handleClose}
                                    style={{cursor: 'pointer'}}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <div ref={exportRef} style={{padding: 20}}>

                                <div
                                    style={{
                                        display: !side1 ? "block" : "none",
                                        margin: 0
                                    }}
                                >
                                    <BoxKitchen
                                        kitchenElements={kitchenElements}
                                        setKitchenElements={setKitchenElements}
                                        isDragDisabled={true}
                                    />
                                </div>

                                <div
                                    style={{
                                        display: (side1 && !side2) ? "block" : "none",
                                        margin: 0
                                    }}
                                >
                                    <BoxKitchen
                                        kitchenElements={kitchenElementsSecondarySide}
                                        setKitchenElements={setKitchenElementsSecondarySide}
                                        isDragDisabled={true}
                                    />
                                </div>

                            </div>

                        </Grid>

                        <Grid item xs={12} md={6} lg={6}>
                            <InputButton
                                variant="outlined"
                                style={{width: '100%'}}
                                text={`← ${t('general.Back')}`}
                                onClick={handleCancel}
                                color="secondary"
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                            <InputButton
                                style={{width: '100%'}}
                                text={isConfirmSlide1 === "" ? `${t('general.Confirm Side')} 1 →` : `${t('general.Confirm Side')} 2 →`}
                                onClick={() => exportAsImage(exportRef.current, "test")}
                                color="primary"
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    )
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: 0,
    boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
    pt: 2,
    px: 4,
    pb: 3,
    borderRadius: '8px',
    backgroundColor: '#fff',
}
